import { backendErrorCodes, frontendFetchErrorCodes } from '@/model/mappingCode/errorCode';
import type { WebAPIError } from '@/store/api/WebApiResponse';
import { FormattedMessage, useIntl } from 'react-intl';

interface Props {
  error: WebAPIError;
}

export function TranslateWebAPIError({ error }: Props) {
  const { $t } = useIntl();
  if (error.type === 'httpFailures') {
    if (typeof error.status === 'number') {
      return $t(
        {
          id: 'global.frontendFailures.HTTPError',
        },
        { statusCode: error.status },
      );
    }

    const { status: errorCode } = error;

    return frontendFetchErrorCodes.includes(errorCode)
      ? $t({
          id: `global.frontendFailures.errorCode.${errorCode}`,
        })
      : $t(
          {
            id: 'global.frontendFailures.unknownErrorCode',
          },
          { errorCode },
        );
  }

  const { errorCode, description } = error.failures[0];

  const descriptionElt = description ? (
    <FormattedMessage id="additionalInformation" values={{ info: description }} />
  ) : null;

  const translatedErrorCode = backendErrorCodes.includes(errorCode)
    ? $t({
        id: `global.backendFailures.errorCode.${errorCode}`,
      })
    : $t(
        {
          id: 'global.backendFailures.unknownErrorCode',
        },
        { errorCode },
      );

  return (
    <>
      {translatedErrorCode}
      <br />
      {descriptionElt}
    </>
  );
}
